import type { DicomTags } from "./DicomDataSet";

export interface IDicomTag {
    name: string;
    tag: string;
    value: string;
    dicomTagKey: DicomTags;
}

export class DicomTag implements IDicomTag {
    constructor(
        public name: string,
        public tag: string,
        public value: string,
        public dicomTagKey: DicomTags,
    ) {}
}
